import {Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {chartColors} from "../../../component/charts/utils/ChartColors";
import {convertCurrencyFormatPositiveNegative} from "@moeindal/base-raiko-panel-components";
import PieChartLineInfo from "../../../component/charts/pieChartWithPaddingAngle/pieChartLineInfo/PieChartLineInfo";
import React from "react";
import {css} from "@emotion/css";

export default function AreaChartDailyCommuting({dailyCommutingData}) {


    return <>
        <ResponsiveContainer className={css`direction: ltr;`}>
            <AreaChart
                data={dailyCommutingData}
                margin={{top: 10, right: 0, left: 0, bottom: 0}}
            >
                {/* گرادیان برای پر کردن زیر نمودار */}
                <defs>
                    <linearGradient id="colorPurple" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor={chartColors.green} stopOpacity={1}/>
                        <stop offset="20%" stopColor={chartColors.green} stopOpacity={0.9}/>
                        <stop offset="95%" stopColor={chartColors.green} stopOpacity={0.1}/>
                    </linearGradient>
                </defs>

                {/* خطوط پس‌زمینه (اختیاری) */}
                <CartesianGrid strokeDasharray="1 2" stroke="#cccccc"/>

                {/* محور افقی */}
                <XAxis
                    dataKey="name"
                    stroke="#aaa"
                    tick={{fontSize: 8, fill: "#1e1e1e"}}
                />

                {/* محور عمودی */}
                <YAxis
                    dataKey="value"
                    stroke="#aaa"
                    tick={{fontSize: 12, fill: "#1e1e1e"}}
                    domain={[0, 10]}

                />

                {/* Tooltip سفارشی */}
                <Tooltip
                    labelFormatter={(label) => ` روز: ${label}`}
                    formatter={(value, name) => {
                        console.log("name ", name)

                        return [`${convertCurrencyFormatPositiveNegative(value)} `,
                            name === "exit" ? "خروج" :
                                name === "resident" ? "استقرار" :
                                    "ورود"]
                    }

                    }
                    contentStyle={{
                        backgroundColor: "#1e1e2f",
                        border: `1px solid ${chartColors.green}`,
                        borderRadius: "5px",
                        direction: "rtl",
                    }}
                    labelStyle={{color: chartColors.green, textAlign: "right"}}
                    itemStyle={{color: "#fff", textAlign: "right"}}
                />

                {/* نمودار اصلی */}

                <Area
                    type="linear"
                    dataKey="value"
                    stroke={chartColors.green}
                    strokeWidth={4}        // 👈 ضخامت خط بالای نمودار
                    fill="url(#null)"
                    activeDot={{r: 6}}   // 👈 نقطه بزرگ‌تر هنگام هاور
                />
                <Area
                    type="linear"
                    dataKey="exit"
                    stroke={chartColors.red}
                    strokeWidth={4}        // 👈 ضخامت خط بالای نمودار
                    fill="url(#null)"
                    activeDot={{r: 6}}   // 👈 نقطه بزرگ‌تر هنگام هاور
                />
                <Area
                    type="linear"
                    dataKey="resident"
                    stroke={chartColors.gold}
                    strokeWidth={4}        // 👈 ضخامت خط بالای نمودار
                    fill="url(#null)"
                    activeDot={{r: 6}}   // 👈 نقطه بزرگ‌تر هنگام هاور
                />
            </AreaChart>
        </ResponsiveContainer>
        <div className={css`display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            gap: 1rem`}>
            <PieChartLineInfo
                color={chartColors.green}
                value={""}
                title={"ورود جدید"}
            />
            <PieChartLineInfo
                color={chartColors.red}
                value={""}
                title={"خروج از اسکان"}
            />
            <PieChartLineInfo
                color={chartColors.gold}
                value={""}
                title={"استقرار یافته"}
            />
        </div>
    </>
}